/**
 * Sections further down the page rise gently into view as the customer scrolls to them. Only sections that start below the
 * first screen are hidden, and only by this script, so nothing is ever hidden without it. Nothing moves when the visitor
 * prefers reduced motion, or in the theme editor, where merchants need to see every section at once.
 */
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.remove('reveal--pending');
      observer.unobserve(entry.target);
    }
  },
  { rootMargin: '0px 0px -8% 0px' },
);

function prepare() {
  if (reduceMotion.matches || window.Shopify?.designMode) return;
  for (const section of document.querySelectorAll('main .shopify-section:not(.reveal)')) {
    section.classList.add('reveal');
    if (section.getBoundingClientRect().top > window.innerHeight) {
      section.classList.add('reveal--pending');
      observer.observe(section);
    }
  }
}

// Printing shows everything, including sections the customer never scrolled to.
window.addEventListener('beforeprint', () => {
  for (const section of document.querySelectorAll('.reveal--pending')) section.classList.remove('reveal--pending');
});

prepare();
